import React, { useEffect, useState } from 'react';
import { IoFilterSharp } from "react-icons/io5";
import { loadLiveNFTCollection, loadNFTsForaCollection } from '../../assets/Data/NFT';
import CollcetionLiveCard from './CollectionLiveCard';
import { listNFTs } from '../../hooks/NFTHook';

const DataOption = [
    { value: "ltoh", text: "Price low to high" },
    { value: "htol", text: "price high to low" },
    { value: "createdAt", text: "recently Listed" },
    { text: "Best Offer" },
    { value: "Art", text: "Art" },
    { value: "Graphics", text: "Graphics" },
    { value: "Video", text: "Video" },
    { value: "Others", text: "Others" },
];

export const CollectionLiveTab = (props) => {
    const [nftCount, setNftCount] = useState(0);
    const contractAddress = props.contractAddress
    const [filter, setFilter] = useState(null);

    useEffect(() => {
        fetchNFTs();
    }, [contractAddress, filter]);

    const fetchNFTs = async () => {
        let Params;
        if (filter === null) {
            Params = { contractAddress: contractAddress }
        }
        if (filter === "createdAt") {
            Params = { contractAddress: contractAddress, sortBy: filter }
        }
        if (filter !== null && filter !== "createdAt") {
            Params = { contractAddress: contractAddress, category: filter }
        }
        const allNFTs = await listNFTs(Params); // Fetch all NFTs
        // console.log("allNFTs", allNFTs);
        if (allNFTs.success)
            setNftCount(allNFTs.total);
    };

    return (
        <div className="Collection_content">
            <div className="items-content">
                <div className='d-flex align-items-center gap-2 live_show'>
                    <div className="sidebar_button">
                        <IoFilterSharp size={18} />
                    </div>
                    <div className="status">
                        <div className="status-indicator">
                            <div className="gif">
                            </div>
                        </div>
                        <div className="status-text">Live</div>
                    </div>
                </div>
                <div className='d-flex align-items-center'>
                    <input type="text" className="search_bar" placeholder="Search..." />
                </div>
                <div className='d-flex align-items-center gap-2'>
                    <div className="result-text" style={{ whiteSpace: "nowrap" }}>{nftCount} results </div>
                    <select className="dropdown" onChange={(e) => setFilter(e.target.value)}>
                        {DataOption.map((data) => (
                            <option value={`${data.value}`}>{data.text}</option>
                        ))}ZXcvbnm,0.
                    </select>
                </div>
            </div>
            <div>
                <div className='py-4'>
                    <CollcetionLiveCard filter={filter} contractAddress={contractAddress} />
                </div>
            </div>
        </div>
    )
};
